/* eslint-disable react/prop-types */
import React from "react";
import Style from "./Navbar.module.scss";
import Toggler from "./home/Toggler";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import { info } from "../info/Info";
import LanguageSwitcher from "./home/LanguageSwitcher";

const links = [
  // { name: 'Başlangıç', to: '/', active: 'home' },
  { name: "About Me", to: "/en/about", active: "about" },
  { name: info.initials, type: "initials", to: "/en", active: "home" },
];

const externalLinks = [
  { label: "My Experiences", href: "https://experiences.berkantaslan.com" },
  { label: "Blog", href: "https://blogs.berkantaslan.com" },
  { label: "Portfolio", href: "https://portfolio.berkantaslan.com" },
  { label: "Contact", href: "https://contact.berkantaslan.com" },
];

const transition = "all 250ms ease";

export default function Navbar({ darkMode, handleClick }) {
  return (
    <Box component={"nav"} width={"100%"} sx={{ overflowX: "hidden" }}>
      {/* Mobile: 3 stacked rows. Desktop: single row */}
      <Box
        display={"flex"}
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={"center"}
        alignItems={"center"}
        gap={{ xs: "0.35rem", md: "2rem", lg: "5rem" }}
        sx={{
          width: "100%",
          px: { xs: 0.5, md: 0 },
        }}
      >
        {/* Group A: internal links */}
        <Box
          component={"ul"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          data-nav="internal"
          sx={{ listStyle: "none", p: 0, m: 0 }}
        >
          {links.map((link, index) => (
            <Box
              key={index}
              component={"li"}
              sx={{
                cursor: "pointer",
                ":hover": {
                  transform: "translateY(-3px)",
                  transition: transition,
                },
              }}
            >
              <Link
                to={link.to}
                className={Style.link}
                style={{ textDecoration: "none" }}
              >
                {link.name !== "About Me" ? (
                  !link.type ? (
                    <p
                      style={{
                        textDecoration: "none",
                        fontFamily: "JetBrains Mono",
                      }}
                    >
                      {link.name}
                    </p>
                  ) : (
                    <h1
                      style={{
                        fontWeight: "bold",
                        textDecoration: "none",
                        fontFamily: "JetBrains Mono",
                      }}
                    >
                      {link.name}
                    </h1>
                  )
                ) : darkMode ? (
                  <p
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontFamily: "JetBrains Mono",
                    }}
                  >
                    {link.name}
                  </p>
                ) : (
                  <p
                    style={{
                      color: "black",
                      textDecoration: "none",
                      fontFamily: "JetBrains Mono",
                    }}
                  >
                    {link.name}
                  </p>
                )}
              </Link>
            </Box>
          ))}
        </Box>

        {/* Group B: external links */}
        <Box
          component={"ul"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexWrap={"wrap"}
          data-nav="external"
          sx={{ listStyle: "none", p: 0, m: 0, columnGap: { xs: "0.35rem", md: "2rem" }, rowGap: { xs: "0.15rem", md: 0 } }}
        >
          {externalLinks.map((item) => (
            <Box
              key={item.label}
              component={"li"}
              sx={{
                cursor: "pointer",
                ":hover": {
                  transform: "translateY(-3px)",
                  transition: transition,
                },
              }}
            >
              <p
                style={{ fontFamily: "JetBrains Mono" }}
                onClick={() => (window.location.href = item.href)}
              >
                {item.label}
              </p>
            </Box>
          ))}
        </Box>

        {/* Group C: controls */}
        <Box
          component={"ul"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ listStyle: "none", p: 0, m: 0 }}
        >
          <li>
            <Toggler darkMode={darkMode} handleClick={handleClick} />
          </li>
          <li>
            <LanguageSwitcher />
          </li>
        </Box>
      </Box>
    </Box>
  );
}
